import gql from "graphql-tag";
import moment from "moment";
import * as React from "react";

import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import ApolloQuery from "#data-access/gql/apollo-query.tsx";

export type Story = {
    key: string;
    name: string;
    formatted_date: string;
    story: string;
    youtube_id: string | null | undefined;
};

type StoriesQueryResult = {
    loading: boolean;
    error: Error | null | undefined;
    stories: Array<Story>;
};

type Props = {
    children: (result: StoriesQueryResult) => React.ReactNode;
};

type Data = {
    recentSubmittedStories?: Array<{
        key: string;
        submitterName: string;
        date: string;
        story: string;
        youtubeId: string | null | undefined;
    }>;
};

export default class StoriesQuery extends React.Component<Props> {
    render(): React.ReactNode {
        const {children} = this.props;

        return (
            <ApolloQuery query={DATA_QUERY} fetchPolicy="cache-first">
                {({data, loading, error}) => {
                    const results = (data && data.recentSubmittedStories) || [];
                    const stories = results.map((story) => ({
                        key: story.key,
                        name: story.submitterName,
                        formatted_date: moment(story.date).format("LL"),
                        story: story.story,
                        youtube_id: story.youtubeId,
                    }));
                    return children({loading, error, stories});
                }}
            </ApolloQuery>
        );
    }
}

const DATA_QUERY: GqlOperation<Data> = gqlOp(gql`
    query getRecentlySubmittedStories {
        recentSubmittedStories {
            key
            submitterName
            date
            story
            youtubeId
        }
    }
`);
